"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Conversation/ScheduledCancelToast.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _scheduledMessages = require('shared/services/scheduledMessages');








// Floats over the thread, just above the composer, for a few seconds after
// Cancel. Undo is there until the cancel is sent; a message that was nearly
// due shows the text alone. The live region stays mounted so screen readers
// hear the text when it appears.
const ScheduledCancelToast = ({ toast, onUndo }) => {
  const undo = _react.useCallback.call(void 0, () => { if (toast) onUndo(toast.key) }, [toast, onUndo])
  return (
    _react2.default.createElement('div', { className: "scheduled-cancel-toast--anchor", role: "status", __self: this, __source: {fileName: _jsxFileName, lineNumber: 19}}
      , toast && (
        _react2.default.createElement('div', { className: "scheduled-cancel-toast", __self: this, __source: {fileName: _jsxFileName, lineNumber: 21}}
          , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 22}}, _scheduledMessages.SCHEDULED_CANCELLED_TEXT)
          , toast.undoable && (
            _react2.default.createElement('button', { type: "button", className: "scheduled-cancel-toast--undo", onClick: undo, __self: this, __source: {fileName: _jsxFileName, lineNumber: 24}}, "Undo")
          )
        )
      )
    )
  )
}

exports. default = _react.memo.call(void 0, ScheduledCancelToast)
